import Activity from "./Activity";
import ActivityCircle from "./ActivityCircle";
import Add from "./Add";
import ArrowDown from "./ArrowDown";
import ArrowDownCircle from "./ArrowDownCircle";
import ArrowLeft from "./ArrowLeft";
import ArrowLeft2 from "./ArrowLeft2";
import ArrowNext from "./ArrowNext";
import ArrowNext2 from "./ArrowNext2";
import ArrowPrev from "./ArrowPrev";
import ArrowPrev2 from "./ArrowPrev2";
import ArrowRight from "./ArrowRight";
import ArrowRight2 from "./ArrowRight2";
import ArrowRightCircle from "./ArrowRightCircle";
import ArrowRightCircle2 from "./ArrowRightCircle2";
import Bell from "./Bell";
import Bell2 from "./Bell2";
import Cancel from "./Cancel";
import Checkbox from "./Checkbox";
import Checkbox2 from "./Checkbox2";
import Close from "./Close";
import Confirm from "./Confirm";
import Download from "./Download";
import EditIcon from "./EditIcon";
import Eye from "./Eye";
import Facebook from "./Facebook";
import Flash from "./Flash";
import Gallery from "./Gallery";
import GameLuckyDraw from "./GameLuckyDraw";
import GameLuckyDrawCircle from "./GameLuckyDrawCircle";
import GoldBtnIcon from "./GoldBtnIcon";
import Google from "./Google";
import Home from "./Home";
import Instagram from "./Instagram";
import Line from "./Line";
import Loading from "./Loading";
import MemberCoperate from "./MemberCoperate";
import MemberPerson from "./MemberPerson";
import MemberPerson2 from "./MemberPerson2";
import MemberPerson3 from "./MemberPerson3";
import MenuBarHistory from "./MenuBarHistory";
import MenuBarHome from "./MenuBarHome";
import MenuBarProfile from "./MenuBarProfile";
import MenuBarScan from "./MenuBarScan";
import MenuBarSong from "./MenuBarSong";
import MenuNews from "./MenuNews";
import MenuPointRedeem from "./MenuPointRedeem";
import MenuProfile from "./MenuProfile";
import MenuReserve from "./MenuReserve";
import MprFreeWiFi from "./MprFreeWiFi";
import MprFreeParking from "./MprFreeParking";
import MprNoSmoking from "./MprNoSmoking";
import MprRoomSize from "./MprRoomSize";
import Music from "./Music";
import MusicNote from "./MusicNote";
import PendingCircle from "./PendingCircle";
import PriorityCircle from "./PriorityCircle";
import Profile from "./Profile";
import ProfileHistory from "./ProfileHistory";
import ProfileLogout from "./ProfileLogout";
import QrCodeMark from "./QrCodeMark";
import Radio from "./Radio";
import RedeemECoupon from "./RedeemECoupon";
import RedeemVoucher from "./RedeemVoucher";
import RedeemGift from "./RedeemGift";
import Resend from "./Resend";
import Scan from "./Scan";
import ShortcutActive from "./ShortcutActive";
import ShortcutGame from "./ShortcutGame";
import ShortcutPriority from "./ShortcutPriority";
import ShortcutSurvey from "./ShortcutSurvey";
import SpecialPoint from "./SpecialPoint";
import StatusCross from "./StatusCross";
import StatusDot from "./StatusDot";
import SubMenuActivity from "./SubMenuActivity";
import SubMenuFav from "./SubMenuFav";
import SubMenuGame from "./SubMenuGame";
import SubMenuProductWarrantee from "./SubMenuProductWarrantee";
import SubMenuSpecialPoint from "./SubMenuSpecialPoint";
import Success from "./Success";
import SuccessIcon from "./SuccessIcon";
import Survey from "./Survey";
import SurveyCircle from "./SurveyCircle";
import Telephone from "./Telephone";
import Trash from "./Trash";
import Tiktok from "./Tiktok";
import UnSuccessIcon from "./UnSuccessIcon";
import Upload from "./Upload";
import Voucher from "./Voucher";
import DropdownArrow from "./DropdownArrow";
import SubMenuBooking from "./SubMenuBooking";
import Warranty from "./Warranty";
import Youtube from "./Youtube";

const EXPORT = {
  Activity,
  ActivityCircle,
  Add,
  ArrowDown,
  ArrowDownCircle,
  ArrowLeft,
  ArrowLeft2,
  ArrowNext,
  ArrowNext2,
  ArrowPrev,
  ArrowPrev2,
  ArrowRight,
  ArrowRight2,
  ArrowRightCircle,
  ArrowRightCircle2,
  Bell,
  Bell2,
  Cancel,
  Checkbox,
  Checkbox2,
  Close,
  Confirm,
  Download,
  EditIcon,
  Eye,
  Facebook,
  Flash,
  Gallery,
  GameLuckyDraw,
  GameLuckyDrawCircle,
  GoldBtnIcon,
  Google,
  Home,
  Instagram,
  Line,
  Loading,
  MemberCoperate,
  MemberPerson,
  MemberPerson2,
  MemberPerson3,
  MenuBarHistory,
  MenuBarHome,
  MenuBarProfile,
  MenuReserve,
  MprFreeWiFi,
  MprFreeParking,
  MprNoSmoking,
  MprRoomSize,
  MenuBarScan,
  MenuBarSong,
  MenuNews,
  MenuPointRedeem,
  MenuProfile,
  Music,
  MusicNote,
  PendingCircle,
  PriorityCircle,
  Profile,
  ProfileHistory,
  ProfileLogout,
  QrCodeMark,
  Radio,
  RedeemECoupon,
  RedeemVoucher,
  RedeemGift,
  Resend,
  Scan,
  ShortcutActive,
  ShortcutGame,
  ShortcutPriority,
  ShortcutSurvey,
  SpecialPoint,
  StatusCross,
  StatusDot,
  SubMenuActivity,
  SubMenuFav,
  SubMenuGame,
  SubMenuProductWarrantee,
  SubMenuSpecialPoint,
  Success,
  SuccessIcon,
  Survey,
  SurveyCircle,
  Telephone,
  Trash,
  Tiktok,
  UnSuccessIcon,
  Upload,
  Voucher,
  DropdownArrow,
  SubMenuBooking,
  Warranty,
  Youtube,
};

export default EXPORT;
